import React, { useState, useEffect } from 'react';
import ContentHeader from '../../components/ContentHeader';
import Loader from "../../components/Loader";
import Swal from "sweetalert2";
import axios from "axios";
import { useNavigate } from 'react-router-dom';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const Company = () => {
    const [loading, setLoading] = useState(false);
    const [company_id, setCompanyId] = useState(1);
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [address, setAddress] = useState('');
    const [logo_main, setLogoMain] = useState('');
    const [logo_secondary, setLogoSecondary] = useState('');
    const [info_report, setInfoReport] = useState('');
    const [mainLogoLoaded, setMainLogoLoaded] = useState(false);
    const [secondaryLogoLoaded, setSecondaryLogoLoaded] = useState(false);
    const navigate = useNavigate();
    const ENDPOINT = process.env.REACT_APP_URL_ENDPOINT;
    const TITLEALERT = process.env.REACT_APP_TITLE_ALERT;
    const URLZFILES = process.env.REACT_APP_API_ZFILES;

    useEffect(() => {
        getCompany();
    }, []);

    const goDashboard = () => {
        navigate('/dashboard');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        await axios.put(ENDPOINT + 'update-company/' + company_id, {
            name: name,
            description: description,
            email: email,
            phone: phone,
            address: address,
            info_report: info_report
        }).then(response => {
            getCompany();
            Swal.fire({
                icon: 'success',
                title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                showConfirmButton: false,
                timer: 3000,
                html: '<div class="text-custom-alert">' + response.data.msg + '</div>',
                showClass: { popup: 'animate__animated animate__fadeInDown' },
                hideClass: { popup: 'animate__animated animate__fadeOutUp' }
            })
        }).catch(function (error) {
            console.log(error)
            setLoading(false);
            Swal.fire({
                icon: 'error',
                title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                showConfirmButton: true,
                timer: 3000,
                html: '<div class="text-custom-alert">' + error.response.data.msg + '</div>',
                showClass: { popup: 'animate__animated animate__fadeInDown' },
                hideClass: { popup: 'animate__animated animate__fadeOutUp' }
            })
        });
    };

    const getCompany = async () => {
        setLoading(true);
        await axios.get(ENDPOINT + 'get-company/' + company_id)
            .then(response => {
                setLoading(false);
                setCompanyId(response.data.data.company_id);
                setName(response.data.data.name);
                setDescription(response.data.data.description);
                setEmail(response.data.data.email);
                setPhone(response.data.data.phone);
                setAddress(response.data.data.address);
                setLogoMain(response.data.data.logo_main);
                setLogoSecondary(response.data.data.logo_secondary);
                setInfoReport(response.data.data.info_report);
            }).catch(function (error) {
                console.log(error)
                setLoading(false);
            });
    };

    const handleFileChangeMain = async (e) => {
        setLoading(true);
        const form = new FormData();
        form.append('file', e.target.files[0]);
        form.append('destination', 'zfiles/company/');
        await axios.post(ENDPOINT + 'upload-logo-company-main', form, {
            headers: { 'Content-Type': 'multipart/form-data' }
        }).then(response => {
            setTimeout(() => {
                const logo_response = response.data.data.pathFile;
                axios.put(ENDPOINT + "update-logo-company-main/" + company_id, { logo_main: logo_response })
                    .then((responsedata) => {
                        setLoading(false);
                        window.location.reload();
                        Swal.fire({
                            icon: "success",
                            title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                            showConfirmButton: false,
                            timer: 3000,
                            html: '<div class="text-custom-alert">' + responsedata.data.msg + "</div>",
                            showClass: { popup: "animate__animated animate__fadeInDown" },
                            hideClass: { popup: "animate__animated animate__fadeOutUp" },
                        });
                    })
            }, 300);
        }).catch(function (error) {
            console.log(error)
            setLoading(false);
            Swal.fire({
                icon: 'error',
                title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                showConfirmButton: true,
                html: '<div class="text-custom-alert">' + error.response.data.msg + '</div>',
                showClass: { popup: 'animate__animated animate__fadeInDown' },
                hideClass: { popup: 'animate__animated animate__fadeOutUp' }
            })
        });
    };

    const handleFileChangeSecondary = async (e) => {
        setLoading(true);
        const form = new FormData();
        form.append('file', e.target.files[0]);
        form.append('destination', 'zfiles/company/');
        await axios.post(ENDPOINT + 'upload-logo-company-secondary', form, {
            headers: { 'Content-Type': 'multipart/form-data' }
        }).then(response => {
            setTimeout(() => {
                const logo_response = response.data.data.pathFile;
                axios.put(ENDPOINT + "update-logo-company-secondary/" + company_id, { logo_secondary: logo_response })
                    .then((responsedata) => {
                        setLoading(false);
                        window.location.reload();
                        Swal.fire({
                            icon: "success",
                            title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                            showConfirmButton: false,
                            timer: 3000,
                            html: '<div class="text-custom-alert">' + responsedata.data.msg + "</div>",
                            showClass: { popup: "animate__animated animate__fadeInDown" },
                            hideClass: { popup: "animate__animated animate__fadeOutUp" },
                        });
                    })
            }, 300);
        }).catch(function (error) {
            console.log(error)
            setLoading(false);
            Swal.fire({
                icon: 'error',
                title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                showConfirmButton: true,
                html: '<div class="text-custom-alert">' + error.response.data.msg + '</div>',
                showClass: { popup: 'animate__animated animate__fadeInDown' },
                hideClass: { popup: 'animate__animated animate__fadeOutUp' }
            })
        });
    }

    const modules = {
        toolbar: [
            [{ 'header': [1, 2, false] }],
            ['bold', 'italic', 'underline', 'strike', 'blockquote'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
            ['link', 'image'],
            ['clean']
        ],
    };

    const formats = [
        'header',
        'bold', 'italic', 'underline', 'strike', 'blockquote',
        'list', 'bullet', 'indent',
        'link', 'image'
    ];

    return (
        <div>
            {loading && <Loader />}
            <div className="container-fluid">
                <ContentHeader title="Módulo de Empresa" />
            </div>
            <div className="container-fluid">
                <div className="row profile">
                    <div className="col-md-4">
                        <div className="card card-company">
                            <div className="card-body pt-5 mt-3">
                                <div className="text-center mb-4">
                                    <div className="profile-avatar-wrapper" style={{
                                        position: 'relative',
                                        textAlign: 'center',
                                        marginBottom: '20px'
                                    }}>
                                        <div className="profile-avatar-container" style={{
                                            width: '200px',
                                            height: '200px',
                                            borderRadius: '50%',
                                            border: '4px solid #fff',
                                            boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                                            overflow: 'hidden',
                                            margin: '0 auto',
                                            position: 'relative'
                                        }}>
                                            {!mainLogoLoaded && <Skeleton height={200} width={200} />}
                                            <img
                                                className="company-logo"
                                                src={URLZFILES + logo_main}
                                                alt="Company"
                                                style={{ 
                                                    display: mainLogoLoaded ? 'block' : 'none',
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'cover'
                                                }}
                                                onLoad={() => setMainLogoLoaded(true)}
                                            />
                                            <div className="avatar-overlay" style={{
                                                position: 'absolute',
                                                top: 0,
                                                left: 0,
                                                right: 0,
                                                bottom: 0,
                                                background: 'rgba(0,0,0,0.5)',
                                                opacity: 0,
                                                transition: 'opacity 0.3s ease',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                cursor: 'pointer'
                                            }}>
                                                <i className="fas fa-camera text-white"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="company-upload">
                                        <label htmlFor="logo-main" className="btn btn-primary w-100 d-flex align-items-center justify-content-center gap-2" style={{
                                            transition: 'all 0.3s ease',
                                            cursor: 'pointer'
                                        }}>
                                            <i className="fas fa-cloud-upload-alt"></i>
                                            Cambiar Logo Principal
                                        </label>
                                        <input 
                                            type="file" 
                                            id="logo-main" 
                                            className="company-upload-input" 
                                            onChange={handleFileChangeMain} 
                                            style={{ display: 'none' }}
                                        />
                                    </div>
                                    <div className="photo-upload-info p-2 mt-2" style={{
                                        background: '#f8f9fa',
                                        borderRadius: '8px',
                                        border: '1px dashed #dee2e6'
                                    }}>
                                        <h6 className="mb-3">
                                            <i className="fas fa-info-circle me-2"></i>
                                            Requisitos de la foto
                                        </h6>
                                        <div className="requirements-grid" style={{
                                            display: 'grid',
                                            gridTemplateColumns: '1fr 1fr',
                                            gap: '10px'
                                        }}>
                                            <div className="requirement-item d-flex align-items-center">
                                                <i className="fas fa-check-circle text-success me-2"></i>
                                                <small>Formato: JPG, PNG</small>
                                            </div>
                                            <div className="requirement-item d-flex align-items-center">
                                                <i className="fas fa-check-circle text-success me-2"></i>
                                                <small>Máx: 2MB</small>
                                            </div>
                                            <div className="requirement-item d-flex align-items-center">
                                                <i className="fas fa-check-circle text-success me-2"></i>
                                                <small>200x200 px</small>
                                            </div>
                                            <div className="requirement-item d-flex align-items-center">
                                                <i className="fas fa-check-circle text-success me-2"></i>
                                                <small>Fondo claro</small>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="card-body pt-5 mt-3">
                                <div className="text-center mb-4">
                                    <div className="profile-avatar-wrapper" style={{
                                        position: 'relative',
                                        textAlign: 'center',
                                        marginBottom: '20px'
                                    }}>
                                        <div className="profile-avatar-container" style={{
                                            width: '200px',
                                            height: '200px',
                                            borderRadius: '50%',
                                            border: '4px solid #fff',
                                            boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                                            overflow: 'hidden',
                                            margin: '0 auto',
                                            position: 'relative'
                                        }}>
                                            {!secondaryLogoLoaded && <Skeleton height={200} width={200} />}
                                            <img
                                                className="company-logo"
                                                src={URLZFILES + logo_secondary}
                                                alt="Secondary Logo"
                                                style={{ 
                                                    display: secondaryLogoLoaded ? 'block' : 'none',
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'cover'
                                                }}
                                                onLoad={() => setSecondaryLogoLoaded(true)}
                                            />
                                            <div className="avatar-overlay" style={{
                                                position: 'absolute',
                                                top: 0,
                                                left: 0,
                                                right: 0,
                                                bottom: 0,
                                                background: 'rgba(0,0,0,0.5)',
                                                opacity: 0,
                                                transition: 'opacity 0.3s ease',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                cursor: 'pointer'
                                            }}>
                                                <i className="fas fa-camera text-white"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="company-upload">
                                        <label htmlFor="logo-secondary" className="btn btn-primary w-100 d-flex align-items-center justify-content-center gap-2" style={{
                                            transition: 'all 0.3s ease',
                                            cursor: 'pointer'
                                        }}>
                                            <i className="fas fa-cloud-upload-alt"></i>
                                            Cambiar Logo Secundario
                                        </label>
                                        <input 
                                            type="file" 
                                            id="logo-secondary" 
                                            className="company-upload-input" 
                                            onChange={handleFileChangeSecondary} 
                                            style={{ display: 'none' }}
                                        />
                                    </div>
                                    <div className="photo-upload-info p-3 mb-3" style={{
                                        background: '#f8f9fa',
                                        borderRadius: '8px',
                                        border: '1px dashed #dee2e6'
                                    }}>
                                        <h6 className="mb-3">
                                            <i className="fas fa-info-circle me-2"></i>
                                            Requisitos de la foto
                                        </h6>
                                        <div className="requirements-grid" style={{
                                            display: 'grid',
                                            gridTemplateColumns: '1fr 1fr',
                                            gap: '10px'
                                        }}>
                                            <div className="requirement-item d-flex align-items-center">
                                                <i className="fas fa-check-circle text-success me-2"></i>
                                                <small>Formato: JPG, PNG</small>
                                            </div>
                                            <div className="requirement-item d-flex align-items-center">
                                                <i className="fas fa-check-circle text-success me-2"></i>
                                                <small>Máx: 2MB</small>
                                            </div>
                                            <div className="requirement-item d-flex align-items-center">
                                                <i className="fas fa-check-circle text-success me-2"></i>
                                                <small>200x200 px</small>
                                            </div>
                                            <div className="requirement-item d-flex align-items-center">
                                                <i className="fas fa-check-circle text-success me-2"></i>
                                                <small>Fondo claro</small>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-8">
                        <div className="card">
                            <div className="card-body">
                                <div className="company-form-header">
                                    <h3 className="company-form-title">Información de la Empresa</h3>
                                    <p className="company-form-subtitle">Complete los datos principales de su empresa para la gestión del sistema</p>
                                </div>
                                <form onSubmit={handleSubmit} className="row">
                                    <div className="col-sm-12">
                                        <div className="form-group">
                                            <label htmlFor="name" className="col-form-label col-form-label-sm">
                                                Nombre de la Empresa <span className="company-required">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                placeholder="Ingrese nombre de la empresa"
                                                id="name"
                                                name="name"
                                                onChange={(e) => setName(e.target.value)}
                                                value={name}
                                                required
                                            />
                                            <small className="company-field-hint">Este nombre se mostrará en todos los documentos generados</small>
                                        </div>
                                    </div>
                                    <div className="col-sm-12">
                                        <div className="form-group">
                                            <label htmlFor="description" className="col-form-label col-form-label-sm">
                                                Descripción <span className="company-required">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                placeholder="Breve descripción de la empresa"
                                                id="description"
                                                name="description"
                                                onChange={(e) => setDescription(e.target.value)}
                                                value={description}
                                                required
                                            />
                                            <small className="company-field-hint">Descripción corta que identifica su empresa</small>
                                        </div>
                                    </div>
                                    <div className="col-sm-6">
                                        <div className="form-group">
                                            <label htmlFor="email" className="col-form-label col-form-label-sm">
                                                Email <span className="company-required">*</span>
                                            </label>
                                            <input
                                                className="form-control form-control-sm"
                                                placeholder="ejemplo@empresa.com"
                                                type="email"
                                                id="email"
                                                name="email"
                                                onChange={(e) => setEmail(e.target.value)}
                                                value={email}
                                                required
                                            />
                                            <small className="company-field-hint">Email principal de contacto</small>
                                        </div>
                                    </div>
                                    <div className="col-sm-6">
                                        <div className="form-group">
                                            <label htmlFor="phone" className="col-form-label col-form-label-sm">
                                                Teléfono <span className="company-required">*</span>
                                            </label>
                                            <input
                                                className="form-control form-control-sm"
                                                placeholder="+00 000000000"
                                                type="tel"
                                                id="phone"
                                                name="phone"
                                                onChange={(e) => setPhone(e.target.value)}
                                                value={phone}
                                                required
                                            />
                                            <small className="company-field-hint">Número de teléfono principal</small>
                                        </div>
                                    </div>
                                    <div className="col-sm-12">
                                        <div className="form-group">
                                            <label htmlFor="address" className="col-form-label col-form-label-sm">
                                                Dirección <span className="company-required">*</span>
                                            </label>
                                            <input
                                                className="form-control form-control-sm"
                                                placeholder="Dirección completa de la empresa"
                                                type="text"
                                                id="address"
                                                name="address"
                                                onChange={(e) => setAddress(e.target.value)}
                                                value={address}
                                                required
                                            />
                                            <small className="company-field-hint">Dirección física completa de la empresa</small>
                                        </div>
                                    </div>
                                    <div className="col-sm-12">
                                        <div className="form-group">
                                            <label htmlFor="info_report" className="col-form-label col-form-label-sm">
                                                Cabecera para Reportes <span className="company-required">*</span>
                                            </label>
                                            <div className="company-editor-container">
                                                <ReactQuill
                                                    theme="snow"
                                                    value={info_report}
                                                    onChange={setInfoReport}
                                                    modules={modules}
                                                    formats={formats}
                                                    placeholder={'Información que aparecerá en el encabezado de los reportes'}
                                                    className="company-editor"
                                                />
                                            </div>
                                            <small className="company-field-hint">Este texto aparecerá como encabezado en todos los reportes generados</small>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="company-form-actions">
                                            <button type='submit' className="btn btn-success btn-sm">
                                                <i className="fa-regular fa-floppy-disk me-2"></i> Actualizar
                                            </button>
                                            <button onClick={goDashboard} type='button' className="btn btn-danger btn-sm">
                                                <i className="fa-solid fa-ban me-1"></i> Cancelar
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Company;